// Access Levels (Privilege Groups) — HikCentral

export type AccessLevelType = 'visitor' | 'employee';

export interface AccessLevel {
  id: string;
  name: string;
  type: AccessLevelType;
  isDefault: boolean;
}

export interface SetDefaultAccessLevelRequest {
  accessLevelId: string;
}

export interface AccessLevelSuccessResponse {
  success: true;
}

export const ACCESS_LEVEL_ERROR_CODES = {
  NOT_FOUND: 'ACS_3003',
  PROVIDER_UNSUPPORTED: 'ACS_3004',
} as const;

export const GUEST_ERROR_CODES = {
  VALID_FROM_IN_PAST: 'GUEST_5006',
  RANGE_TOO_LONG: 'GUEST_5008',
  INVALID_DATE_FORMAT: 'GUEST_5009',
  VALID_FROM_AFTER_VALID_TO: 'GUEST_5010',
  ACCESS_LEVEL_NOT_CONFIGURED: 'GUEST_5011',
} as const;
